import SvgIconTipperVehicle from "./SvgIconTipperVehicle";
import SvgIconGeneralFreightVehicle from "./SvgIconGeneralFreightVehicle";
import SvgIconMotorcycleVehicle from "./SvgIconMotorcycleVehicle";
import SvgIconEarthmovingVehicle from "./SvgIconEarthmovingVehicle";
import SvgIconCarVehicle from "./SvgIconCarVehicle";
import SvgIconExcavatorVehicle from "./SvgIconExcavatorVehicle";
import SvgIconTrayVehicle from "./SvgIconTrayVehicle";
class VehicleTypeCategorySvgIcons {
    static svgIconFromVehicleTypeCategoryName(name) {
        switch (name) {
            case "TAUTLINER":
            case "PANTEC":
            case "VAN":
            case "PRIME_MOVER":
                return SvgIconGeneralFreightVehicle;
            case "BICYCLE":
            case "MOTORCYCLE":
                return SvgIconMotorcycleVehicle;
            case "CAR":
                return SvgIconCarVehicle;
            case "EXCAVATOR":
                return SvgIconExcavatorVehicle;
            case "UTE":
            case "TRAY":
                return SvgIconTrayVehicle;
            case "LOADER":
            case "DOZER":
            case "BACKHOE":
            case "GRADER":
            case "SKID_STEER":
            case "COMPACTOR":
            case "WATER_CART":
            case "SCRAPER":
            case "STREET_SWEEPER":
            case "ARTICULATED_DMP_TRUK":
            case "CRANE_TRUCK":
                return SvgIconEarthmovingVehicle;
            case "TIPPER":
            default:
                return SvgIconTipperVehicle;
        }
    }
}
export default VehicleTypeCategorySvgIcons;
